import * as Yup from 'yup';
import { useSnackbar } from 'notistack';
import { useState } from 'react';
// next
import { useRouter } from 'next/router';
// form
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
// @mui
import { Stack, IconButton, InputAdornment } from '@mui/material';
import { LoadingButton } from '@mui/lab';
// routes
import { PATH_AUTH } from '../../../routes/paths';
// components
import Iconify from '../../../components/Iconify';
import { FormProvider, RHFTextField } from '../../../components/hook-form';

import axios from 'axios';
// config
import { EVENT_ID, INPUT_ID } from '../../../config';

// ----------------------------------------------------------------------

export default function NewPasswordForm() {
  const router = useRouter();
  const { b, t } = router.query;

  const { enqueueSnackbar } = useSnackbar();

  const [showPassword, setShowPassword] = useState(false);

  const NewPasswordSchema = Yup.object().shape({
    password: Yup.string().required('비밀번호를 입력하세요'),
  });

  const methods = useForm({
    resolver: yupResolver(NewPasswordSchema),
    defaultValues: { password: '' },
  });

  const {
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  const onSubmit = async (data) => {
    try {
      if (!b || !t) {
        enqueueSnackbar('주소가 잘못되었습니다.', { variant: 'warning' })
        router.push(PATH_AUTH.login);
      } else {
        const response = await axios.post(`${process.env.HOST_API_KEY}/api/accounts/reset-password/`, {
          uid: b,
          token: t,
          password: data.password,
        });
        const { status } = response;
        if (status === 200) {
          enqueueSnackbar('비밀번호가 변경되었습니다.', { variant: 'success' })
          router.push(PATH_AUTH.login);
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <Stack spacing={3}>
      <RHFTextField
          name="password"
          label="비밀번호"
          id={INPUT_ID.newpasswordPassword}
          type={showPassword ? 'text' : 'password'}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                  <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />

        <LoadingButton id={EVENT_ID.bizResetPassword} fullWidth size="large" type="submit" variant="contained" loading={isSubmitting}>
          비밀번호 변경하기
        </LoadingButton>
      </Stack>
    </FormProvider>
  );
}
